import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Layout } from "@/components/layout/Layout";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Skeleton } from "@/components/ui/skeleton";

interface AccountLayoutProps {
  children: React.ReactNode;
}

const TABS = [
  { value: "resumen", label: "Resumen", path: "/mi-cuenta" },
  { value: "reviews", label: "Mis reviews", path: "/mi-cuenta/reviews" },
  { value: "perfil", label: "Mi perfil", path: "/mi-cuenta/perfil" },
];

export default function AccountLayout({ children }: AccountLayoutProps) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (loading) {
    return (
      <Layout>
        <div className="container py-8">
          <Skeleton className="h-64" />
        </div>
      </Layout>
    );
  }

  if (!user) return <Navigate to="/auth" />;

  const currentTab = TABS.find((t) => location.pathname === t.path)?.value
    ?? (location.pathname.startsWith("/mi-cuenta/reviews") ? "reviews" : "resumen");

  return (
    <Layout>
      <div className="container py-8">
        <h1 className="mb-6 font-display text-2xl font-bold">Mi cuenta</h1>
        <Tabs value={currentTab} onValueChange={(v) => {
          const tab = TABS.find((t) => t.value === v);
          if (tab) navigate(tab.path);
        }}>
          <TabsList className="mb-6">
            {TABS.map((tab) => (
              <TabsTrigger key={tab.value} value={tab.value}>
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
        {children}
      </div>
    </Layout>
  );
}
